import { render, staticRenderFns } from "./AgentTestimonials.vue?vue&type=template&id=396d63c6"
import script from "./AgentTestimonials.vue?vue&type=script&lang=js"
export * from "./AgentTestimonials.vue?vue&type=script&lang=js"
import style0 from "./AgentTestimonials.vue?vue&type=style&index=0&id=396d63c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports